module.exports = __webpack_public_path__ + "img/WhatsApp_onLight.dbbdae99.svg";